import { useState } from "react";

const inputCls = "w-full rounded-xl border border-violet-200 bg-white px-3.5 py-2.5 text-sm text-[#13052A] focus:border-[#7C3AED] focus:outline-none focus:ring-2 focus:ring-violet-200 read-only:bg-slate-50";

const toText = (f, v) => {
  if (f.type === "list") return (Array.isArray(v) ? v : []).join("\n");
  if (f.type === "json") return JSON.stringify(v ?? [], null, 2);
  return v ?? "";
};

export const fromText = (f, v) => {
  if (f.type === "list") return String(v).split("\n").map((x) => x.trim()).filter(Boolean);
  if (f.type === "json") return JSON.parse(v || "[]");
  if (f.type === "number") return Number(v) || 0;
  return v;
};

export const FieldInput = ({ f, value, onChange }) => {
  const [text, setText] = useState(() => toText(f, value));
  const [err, setErr] = useState("");
  const id = `fld-${f.key}`;

  if (f.type === "bool") {
    return (
      <label className="flex items-center gap-3 text-sm font-bold text-[#13052A]">
        <input type="checkbox" checked={!!value} onChange={(e) => onChange(e.target.checked)} className="h-4 w-4 accent-[#7C3AED]" data-testid={`admin-field-${f.key}`} />
        {f.label}
      </label>
    );
  }
  const handle = (v) => {
    setText(v);
    try { onChange(fromText(f, v)); setErr(""); } catch { setErr("Invalid JSON. Fix before saving"); onChange(undefined); }
  };
  const multi = ["textarea", "list", "json"].includes(f.type);
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-xs font-bold uppercase tracking-wider text-[#581C87]">{f.label}</label>
      {multi ? (
        <textarea id={id} rows={f.rows || (f.type === "json" ? 8 : 4)} className={`${inputCls} ${f.type === "json" ? "font-mono text-xs" : ""}`} value={text} onChange={(e) => handle(e.target.value)} data-testid={`admin-field-${f.key}`} />
      ) : (
        <input id={id} type={f.type === "number" ? "number" : "text"} readOnly={f.readOnly} className={inputCls} value={text} onChange={(e) => handle(e.target.value)} data-testid={`admin-field-${f.key}`} />
      )}
      {f.hint && <p className="mt-1 text-xs text-slate-500">Format: {f.hint}</p>}
      {f.note && <p className="mt-1 text-xs text-slate-500">{f.note}</p>}
      {f.validate && text.trim() && !f.validate(text) && <p className="mt-1 text-xs font-semibold text-amber-700" data-testid={`admin-field-${f.key}-warning`}>{f.invalidMsg}</p>}
      {err && <p className="mt-1 text-xs font-semibold text-red-600">{err}</p>}
    </div>
  );
};
